import { APP_DEFAULT_ENV_STR } from "../core/constants/appGlobals";
import User from "../core/models/User";
import { SessionCache } from "../helpers/cache";
import BaseService from "./BaseService";

export default class GoogleAnalyticsService extends BaseService {
  sendPageViewEvent() {
    const cache = new SessionCache();
    const storedUser: User | null = cache.get("user");

    const custom_props = {
      user_name: storedUser?.name,
      user_email: storedUser?.email,
      environment: process.env.REACT_APP_LOG_ENV ?? APP_DEFAULT_ENV_STR,
    };

    window?.gtag("set", {
      ...custom_props,
    });

    window?.gtag("event", "page_view", {
      ...custom_props,
    });
  }
}
